// src/components/layout-component/Layout.jsx
import React from 'react';
import Header from '../header-component/Header';
import { Box } from '@mui/material';

function Layout({ children }) {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh',
        // backgroundColor: '#F6F3FF' // ← ДОДАЙТЕ ЦЕЙ РЯДОК
      }}
    >
      <Header />
      <Box sx={{ flex: 1, p: 0 }}>{children}</Box>
    </Box>
  );
}

export default Layout;